
import { Component, Vue, Watch } from "vue-property-decorator";
import { ValidationProvider, extend, ValidationObserver } from "vee-validate";
import VueRecaptcha from "vue-recaptcha";
import ConsultaFallecido from "@/models/ConsultaFallecido";
import AfiliadoService from "@/services/AfiliadoService";
import IframeCommunicatorService, {
  InterPagesMessages,
  MessageTypes,
} from "@/services/IframeCommunicatorService";

import Inputmask from "inputmask";
import validateDominicanId from "validacion-cedula-dominicana";
import { formatCedula } from "@/utils/HelperFunctions";
import VeeValidateForm from "@/vee-validate/types/VeeValidateForm";
import { Getter } from "vuex-class";
import User from "@/models/User";
Vue.directive("input-mask", {
  update: function (el: any, binding: any, vnode: any) {
    const mascara: string = vnode.data.attrs.mask;
    const im = new Inputmask(mascara);
    im.mask(el);
  },
});
@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
    VueRecaptcha,
  },
})
export default class ConsultaAfiliadoFallecido extends Vue {
  public consultaFallecidoForm: ConsultaFallecido = new ConsultaFallecido();
  public afiliadoService = new AfiliadoService();
  public showCaptchaMessage: boolean = false;
  public showResult: boolean = false;
  public estadoResultado: string = "";
  public aplicaTramite: boolean = false;
  public loading: boolean = false;
  public nombreResultado = "N/A";
  public cedulaAfiliadoFallecido = "00000000000";
  public mensajeResultado = "";
  public isRedirectToLogin = true;
  public showErrorMessage = false;
  @Getter("isLoggedIn") isLoggedIn: boolean;
  @Getter("user") user: User;
  public iframeService = new IframeCommunicatorService();
  public showServerErrorMessage = false;
  public serverErrorMessage = "";
  public userIpAddress: string = null;

  public async mounted(): Promise<void> {
    if (this.isLoggedIn) {
      this.consultaFallecidoForm.cedulaBeneficiario = this.user.cedula;
    }
    try {
      this.userIpAddress = (
        await this.afiliadoService.getUserIpAddress()
      ).data.ip;
    } catch (err) {
      console.error(err);
      this.loading = true;
      this.showServerErrorMessage = true;
      this.serverErrorMessage =
        "No se pudo obtener la dirección IP del consultante, por favor, recarga la página.";
    }
  }

  get isCaptchaValid(): boolean {
    return this.consultaFallecidoForm.captchaToken.length > 0;
  }

  get cedulaIsValid(): boolean {
    return (
      (this.isLoggedIn ||
        validateDominicanId(this.consultaFallecidoForm.cedulaBeneficiario)) &&
      validateDominicanId(this.consultaFallecidoForm.cedulaFallecido)
    );
  }

  get cedulasMatch(): boolean {
    return (
      this.consultaFallecidoForm.cedulaBeneficiario &&
      this.consultaFallecidoForm.cedulaBeneficiario !== "" &&
      this.consultaFallecidoForm.cedulaFallecido &&
      this.consultaFallecidoForm.cedulaFallecido !== "" &&
      this.consultaFallecidoForm.cedulaBeneficiario ===
        this.consultaFallecidoForm.cedulaFallecido
    );
  }

  get verificarBtnIsDisable(): boolean {
    return (
      !this.cedulaIsValid ||
      this.cedulasMatch ||
      (this.isLoggedIn && !this.consultaFallecidoForm.cedulaBeneficiario) ||
      !this.consultaFallecidoForm.cedulaFallecido
    );
  }

  public sendForm() {
    this.validateCaptcha();
    this.showErrorMessage = false;
    this.showServerErrorMessage = false;

    (this.$refs.form as VeeValidateForm).validate().then((isValid: boolean) => {
      if (!this.cedulasMatch && isValid && this.isCaptchaValid) {
        if (this.isLoggedIn && this.user) {
          this.consultaFallecidoForm.cedulaBeneficiario = this.user.cedula;
        }
        this.loading = true;
        this.$store.dispatch(
          "setCedulaFallecidoAction",
          this.consultaFallecidoForm.cedulaFallecido
        );
        this.afiliadoService
          .consultarAfiliadoFallecido(this.consultaFallecidoForm)
          .then((response) => {
            (this.$refs.recaptcha as any).reset(); ///
            let result = response.data;
            //
            switch (result.respCode) {
              case 200:
                this.showResult = true;
                this.nombreResultado = "N/A";
                this.cedulaAfiliadoFallecido =
                  this.consultaFallecidoForm.cedulaFallecido;
                this.estadoResultado = result.entity.validacionFallecido.estado;
                this.aplicaTramite =
                  result.entity.validacionFallecido.aplicaTramite;
                const requiereDocumento =
                  result.entity.validacionFallecido.requiereDocumento;
                this.$store.dispatch(
                  "setAplicaTramiteAction",
                  this.aplicaTramite
                );
                this.$store.dispatch(
                  "setRequiereDocumentoAction",
                  requiereDocumento
                );
                this.consultaFallecidoForm.captchaToken = "";
                if (
                  result.entity.validacionFallecido.primerNombre &&
                  result.entity.validacionFallecido.primerApellido
                ) {
                  this.nombreResultado =
                    result.entity.validacionFallecido.primerNombre +
                    " " +
                    (result.entity.validacionFallecido.segundoNombre || "") +
                    " " +
                    result.entity.validacionFallecido.primerApellido +
                    " " +
                    (result.entity.validacionFallecido.segundoApellido || "");
                  this.$store.dispatch(
                    "setNombreAfiliadoFallecidoAction",
                    this.nombreResultado
                  );
                }
                this.mensajeResultado =
                  result.entity.validacionFallecido.mensaje;
                //
                if (!result.entity.validacionBeneficiario.estaRegistrado) {
                  this.$store.dispatch(
                    "setCedulaBeneficiarioNoRegistradoAction",
                    this.consultaFallecidoForm.cedulaBeneficiario
                  );
                }
                // Beneficiario
                this.isRedirectToLogin =
                  result.entity.validacionBeneficiario.estaRegistrado;
                //
                Vue.nextTick(() => {
                  this.scrollToSearchResult();
                });
                break;
              case 400:
                this.afiliadoService
                  .ObtenerSolicitudAfiliado(this.consultaFallecidoForm)
                  .then((response) => {
                    let result = response.data;
                    if (result && result.entity) {
                      const numeroSolicitud = result.entity.numeroSolicitud;
                      if (numeroSolicitud) {
                        window.location.href = `/registro-sobrevivencia?numeroSolicitud=${numeroSolicitud}`;
                      }
                    }
                  });
                break;
              default:
                this.serverErrorMessage = this.isLoggedIn
                  ? "Ya has reportado el fallecimiento de este afiliado."
                  : "Este afiliado ya ha sido reportado por este beneficiario.";
                this.showServerErrorMessage = true;
                break;
            }

            this.loading = false;
          })
          .catch((error) => {
            console.error(error);
            this.loading = false;
            this.showErrorMessage = true;
          })
          .finally(() => {
            // Clear captcha token
            this.showCaptchaMessage = false;
            this.consultaFallecidoForm.captchaToken = "";
          });
      }
    });
  }

  public onCaptchaSuccess(token: any) {
    this.consultaFallecidoForm.captchaToken = token;
  }

  public onCaptchaExpire(result: any) {
    this.consultaFallecidoForm.captchaToken = "";
  }

  public validateCaptcha() {
    this.showCaptchaMessage = true;
  }

  public scrollToSearchResult(): void {
    let captchaContainer = this.$refs.captchaContainer as any;
    setTimeout(() => {
      // this.iframeService.postMessageToParent(new InterPagesMessages(MessageTypes.ScrollTo, captchaContainer.id));
      captchaContainer.scrollIntoView({
        block: "start",
        behavior: "smooth",
      });
    }, 500);
  }

  public redirectToLoginOrRegister(): void {
    if (this.isRedirectToLogin) {
      this.$router.push("/actualizacion-datos");
    } else {
      this.$router.push("/registro-beneficiario");
    }
  }

  public formatUserCedula(cedula: string): string {
    return formatCedula(cedula);
  }
  @Watch("consultaFallecidoForm.cedulaBeneficiario")
  public cedulaBeneficiarioWatch(value) {
    if (value != null) {
      this.consultaFallecidoForm.cedulaBeneficiario =
        this.consultaFallecidoForm.cedulaBeneficiario.replace(/\D/g, "");
    }
  }
  @Watch("consultaFallecidoForm.cedulaFallecido")
  public cedulaFallecidoWatch(value) {
    if (value != null) {
      this.consultaFallecidoForm.cedulaFallecido =
        this.consultaFallecidoForm.cedulaFallecido.replace(/\D/g, "");
    }
  }

  pasteHandlerCedulaFallecido(e) {
    console.log(e.clipboardData.getData("text"));
    this.consultaFallecidoForm.cedulaFallecido =
      e.clipboardData.getData("text");
  }
  pasteHandlerCedulaBeneficiario(e) {
    console.log(e.clipboardData.getData("text"));
    this.consultaFallecidoForm.cedulaBeneficiario =
      e.clipboardData.getData("text");
  }
}
